module.exports = __webpack_public_path__ + "images/ui/icon_ranking_leaf_bronze_068bf7ad337e36126dde7b965666f421.svg";